import { render, staticRenderFns } from "./DonationsPage.vue?vue&type=template&id=305dac15&scoped=true&"
import script from "./DonationsPage.vue?vue&type=script&lang=js&"
export * from "./DonationsPage.vue?vue&type=script&lang=js&"
import style1 from "./DonationsPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305dac15",
  null
  
)

export default component.exports